import React from 'react';
import Tabs from 'components/utilities/tabs/Tabs';
import { useSelector } from 'react-redux';

// Import helrpes
import { eventsLiveTabs } from './helpers/index';

const EventsLiveTabs = () => {
	const { languages: contentTranslationLanguages } = useSelector(
		({ content_translations }) => content_translations.language_list
	);
	return <Tabs tabs={eventsLiveTabs(contentTranslationLanguages)} />;
};

export default EventsLiveTabs;
